export enum ApiDomain {
  API = 'api',
  STATS = 'stats',
}
